import attributes from '../constants/attributes';

const getVariationIdByElement = (element) => {
  if (!element) return null;

  return element.getAttribute(attributes.VARIATION_ATTRIBUTE_NAME);
};

export default getVariationIdByElement;
